import z from 'zod';

import { AccessoryCategoryMappingDtoSchema } from './AccessoryCategoryMappingDto';
import { AccessoryCategoryMappingDto } from './AccessoryCategoryMappingDto';
import { CarbonDioxideDisplayLabelDtoSchema } from './CarbonDioxideDisplayLabelDto';
import { CarbonDioxideDisplayLabelDto } from './CarbonDioxideDisplayLabelDto';
import { CharacteristicSchema } from './Characteristic';
import { Characteristic } from './Characteristic';
import { ResizableMediaDtoSchema } from './ResizableMediaDto';
import { ResizableMediaDto } from './ResizableMediaDto';
import { TagMappingDtoSchema } from './TagMappingDto';
import { TagMappingDto } from './TagMappingDto';

export type AccessoryListItemDto = {
	id: string;
	name: string;
	density: number | null;
	price: number | null;
	currencyCode: string | null;
	characteristic: Characteristic | null;
	lastEditor: string | null;
	updatedBy: string | null;
	lastEditedDateUtc: string;
	image: ResizableMediaDto | null;
	carbonDioxideValue: number | null;
	carbonDioxideLabel: CarbonDioxideDisplayLabelDto | null;
	countOfRecipes: number;
	categories: AccessoryCategoryMappingDto[];
	tags: TagMappingDto[];
};

export const AccessoryListItemDtoSchema: z.ZodType<AccessoryListItemDto> = z.object({
	id: z.string(),
	name: z.string(),
	density: z.number().nullable(),
	price: z.number().nullable(),
	currencyCode: z.string().nullable(),
	characteristic: z.lazy(() => CharacteristicSchema).nullable(),
	lastEditor: z.string().nullable(),
	updatedBy: z.string().nullable(),
	lastEditedDateUtc: z.string(),
	image: z.lazy(() => ResizableMediaDtoSchema).nullable(),
	carbonDioxideValue: z.number().nullable(),
	carbonDioxideLabel: z.lazy(() => CarbonDioxideDisplayLabelDtoSchema).nullable(),
	countOfRecipes: z.number(),
	categories: z.lazy(() => AccessoryCategoryMappingDtoSchema).array(),
	tags: z.lazy(() => TagMappingDtoSchema).array(),
});
